import React from 'react';
import { Icon } from 'semantic-ui-react';
import { FULFILLMENT_TYPE_TO_ICON_NAME } from './FulfillmentTypePicker.constants';
import { ChildrenPropType } from '../../../../services/proptypes';
import { FULFILLMENT_TYPE_TO_TEXT } from '../../constants';
import './FulfillmentTypePicker.css';
var defaultProps = {
  title: undefined,
  isSelected: false,
  isAvailable: true,
  disabled: false,
  children: null
};
function FultillmentTypePicker(_ref) {
  var type = _ref.type,
    isSelected = _ref.isSelected,
    isAvailable = _ref.isAvailable,
    disabled = _ref.disabled,
    onSelect = _ref.onSelect,
    children = _ref.children,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "fulfillment-type-picker ".concat(isSelected ? 'selected' : ''),
    onClick: function onClick() {
      return onSelect(type);
    },
    disabled: disabled || !isAvailable
  }, /*#__PURE__*/React.createElement("div", {
    className: "fulfillment-type-picker-header"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    name: FULFILLMENT_TYPE_TO_ICON_NAME[type]
  })), /*#__PURE__*/React.createElement("h4", null, title || FULFILLMENT_TYPE_TO_TEXT[type])), /*#__PURE__*/React.createElement("div", {
    className: "fulfillment-type-picker-content"
  }, isAvailable ? children : /*#__PURE__*/React.createElement("p", null, "Currently Unavailable")));
}
FultillmentTypePicker.defaultProps = defaultProps;
export default FultillmentTypePicker;